import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'primereact/steps';
import { Toast } from 'primereact/toast';

const HorizontalStepperPM = ({ stepItems = null, activeStep = null, toast = null }) => {
  HorizontalStepperPM.propTypes = {
    stepItems: PropTypes.array,
    activeStep: PropTypes.number,
    toast: PropTypes.any,
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <Steps model={stepItems} activeIndex={activeStep} />
    </React.Fragment>
  );
};

export default HorizontalStepperPM;